export default __webpack_public_path__ + "static/media/image32.d78ba553.png";